
export const organisationPage = {
    ORGANISATION_FOLDER: 'ORGANISATION_FOLDER',
    ORGANISATION_ATTACHMENTS: 'ORGANISATION_ATTACHMENTS',
    ORGANISATION_FOLDER_CONTENTS: 'ORGANISATION_FOLDER_CONTENTS',
    ORGANISATION_FOLDER_CONTENTS_DETAILS: 'ORGANISATION_FOLDER_CONTENTS_DETAILS',
}
